import { createContext } from 'react';

const LoginContext = createContext(null);

export default LoginContext;
